let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1yyeS")).then(() => parcelRequire('lsY4K'));